export class ClassTemplate{
	_id: string;
	id: string;
	course_id: any;
	title: string;
	topic_id:any [];
	notes: string;
	admin_notes: string;
}